const MOSCOW_TIMEZONE = 'Europe/Moscow';

const dateFormatterRuMsk = new Intl.DateTimeFormat('ru-RU', {
  timeZone: MOSCOW_TIMEZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});

const dateTimeFormatterRuMsk = new Intl.DateTimeFormat('ru-RU', {
  timeZone: MOSCOW_TIMEZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
});

export const formatDateMsk = (value: string | number | Date): string => {
  return dateFormatterRuMsk.format(new Date(value));
};

export const formatDateTimeMsk = (value: string | number | Date): string => {
  return dateTimeFormatterRuMsk.format(new Date(value));
};

